




























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { validateNotEmpty } from '@/utils/form-validation';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';
import { Collection } from '@/resource/collection/collection.model';

@Component({
  components: {
    BeatLoader,
  },
})
export default class CollectionTitle extends Vue {
  @Prop()
  collection!: Collection;

  @Prop()
  totalQuestions!: number;

  @Prop()
  updateCollectionName!: (collection: Collection) => Promise<void>;

  showNameInput = false;
  name = '';
  nameInput = '';
  nameInputLength = this.name.length;
  nameError: string | boolean = false;
  isLoading = false;

  created() {
    this.name = this.collection.name;
    this.nameInput = this.name;
  }

  openNameInput() {
    this.nameInput = this.name;
    this.showNameInput = true;
  }

  async saveSubmitted() {
    if (this.isLoading) return;
    this.isLoading = true;
    let hasError = false;

    if (!validateNotEmpty(this.nameInput)) {
      this.nameError = 'Name cannot empty';
      hasError = true;
    } else {
      this.nameError = false;
    }

    if (hasError) {
      this.isLoading = false;
      return;
    }

    this.collection.name = this.nameInput;
    await this.updateCollectionName(this.collection);

    this.name = this.nameInput;
    this.showNameInput = false;
    this.isLoading = false;
  }

  @Watch('nameInput')
  currentNameInputLength() {
    this.nameInputLength = this.nameInput.length;
  }
}
